import React, {useContext, useState} from "react";
import {useMediaQuery} from 'react-responsive';
import {useHistory} from "react-router";

import mainImage from "../../assets/images/content/glowna_foto_new.jpg";
import mainImageMobile from "../../assets/images/content/glowna_foto_mobile.jpg";
import dostawczeImage from "../../assets/images/content/hero dostawcze.png";

import BrandAndModelSearch from "../../components/ProductSearchField/BrandAndModelSearch";
import RangeSelect from "../../components/ProductSearchField/RangeSelect";
import MultipleItemsSearchSelect from "../../components/ProductSearchField/MultipleItemsSearchSelect";
import OurStrengths from "./OurStrengths";

import {SearchOptionsContext} from "../../context/search-options-context";
import {CustomerTypeContext} from "../../context/customer-type-context";

import URLSearchParamsConverter from "../../utils/URLSearchParamsConverter";
import analytics from "../../utils/analytics";
import logoIcon from "../../assets/images/icons/logo_icon.svg";
import logoIconWhite from "../../assets/images/icons/logo_icon_white.svg";



function Intro() {
    const isMobile = useMediaQuery({query: '(max-width: 767px)'});

    let searchOptions = useContext(SearchOptionsContext);
    let searchOptionsForDeliveryCars = searchOptions.deliveryCars;
    let searchOptionsForPassengerCars = searchOptions.passengerCars;
    const [customerType, setCustomerType, availableCustomerTypes] = useContext(CustomerTypeContext);
    const history = useHistory();

    const [priceMode, setPriceMode] = useState("RATA");
    const [onlyNew, setOnlyNew] = useState(false);

    const [searchParameters, setSearchParameters] = useState({
        vehicleTypes: "OSOBOWE",
        brands: [],
        models: [],
        segments: [],
        bodyTypes: [],
        fuelTypes: [],
        installmentNetFrom: "",
        installmentNetTo: "",
        installmentGrossFrom: "",
        installmentGrossTo: "",
        minimumSellPriceNetFrom: "",
        minimumSellPriceNetTo: "",
        minimumSellPriceGrossFrom: "",
        minimumSellPriceGrossTo: "",
    });

    const changePropertyHandler = (propertyName, value) => {
        setSearchParameters(prevSearchParameters => {
            let searchParams = prevSearchParameters;
            searchParams[propertyName] = value;
            return searchParams;
        });
    };

    const changeBudgetHandler = (budget) => {
        const isCompany = customerType === availableCustomerTypes.company;
        if (priceMode === "RATA") {
            if (isCompany) {
                setSearchParameters(prev => ({
                    ...prev,
                    installmentNetFrom: budget.from,
                    installmentNetTo: budget.to,
                    installmentGrossFrom: null,
                    installmentGrossTo: null,
                }));
            } else {
                setSearchParameters(prev => ({
                    ...prev,
                    installmentGrossFrom: budget.from,
                    installmentGrossTo: budget.to,
                    installmentNetFrom: null,
                    installmentNetTo: null,
                }));
            }
        } else {
            if (isCompany) {
                setSearchParameters(prev => ({
                    ...prev,
                    minimumSellPriceNetFrom: budget.from,
                    minimumSellPriceNetTo: budget.to,
                    minimumSellPriceGrossFrom: null,
                    minimumSellPriceGrossTo: null,
                }));
            } else {
                setSearchParameters(prev => ({
                    ...prev,
                    minimumSellPriceGrossFrom: budget.from,
                    minimumSellPriceGrossTo: budget.to,
                    minimumSellPriceNetFrom: null,
                    minimumSellPriceNetTo: null,
                }));
            }
        }
    };

    const searchButtonClicked = (openFilter) => {
        analytics.sendEvent({
            category: 'BOX - Szukaj',
            action: 'Klikniecie',
            label: 'Kliknieto w Szukaj',
            value: 1
        });
        history.push({
            pathname: "/lista-ofert",
            search: URLSearchParamsConverter.createURLSearchString({
                ...searchParameters,
                newUsed: onlyNew ? "new" : "",
            }) + (openFilter ? "&filterClicked=true" : "")
        });
    };

    const vehicleTypeHandler = (type) => {
        setSearchParameters(prev => ({...prev, vehicleTypes: type}));
    };

    const isPersonCustomer = customerType === availableCustomerTypes.person;
    const isOsobowe = searchParameters.vehicleTypes === "OSOBOWE";

    // Longhand-only properties (no shorthand `background`) so React reliably
    // diffs and re-applies the style when backgroundImage changes.
    const backgroundImage = isOsobowe
        ? (isMobile ? mainImageMobile : mainImage)
        : dostawczeImage;
    const backgroundStyle = {
        backgroundImage: `url("${backgroundImage}")`,
        backgroundRepeat: "no-repeat",
        backgroundColor: "#fff",
        backgroundSize: "cover"
    };
    // OurStrengths always uses the desktop photo (not the mobile-cropped
    // one) so the "mini hero" card matches the desktop hero image exactly.
    const ourStrengthsBackgroundImage = isOsobowe ? mainImage : dostawczeImage;

    if (searchParameters.vehicleTypes === "DOSTAWCZE") {
        searchOptions = searchOptionsForDeliveryCars;
    } else {
        searchOptions = searchOptionsForPassengerCars;
    }

    const segmentOrBodyItems = isOsobowe ? searchOptions.segments : searchOptions.bodyTypes;
    const segmentOrBodyKey = isOsobowe ? "segments" : "bodyTypes";

    const isCompany = customerType === availableCustomerTypes.company;
    let rangeItems, rangeFrom, rangeTo;
    if (priceMode === "RATA") {
        rangeItems = searchOptions.installments;
        rangeFrom = isCompany ? searchParameters.installmentNetFrom : searchParameters.installmentGrossFrom;
        rangeTo = isCompany ? searchParameters.installmentNetTo : searchParameters.installmentGrossTo;
    } else {
        rangeItems = searchOptions.prices;
        rangeFrom = isCompany ? searchParameters.minimumSellPriceNetFrom : searchParameters.minimumSellPriceGrossFrom;
        rangeTo = isCompany ? searchParameters.minimumSellPriceNetTo : searchParameters.minimumSellPriceGrossTo;
    }

    return (
        <div id="home-intro" style={backgroundStyle}>
            <div className="container flex flex-wrap">
                <div id="search-form" className="container">
                    <div className="search-card">
                        <div className="search-card-tabs">
                            <button
                                type="button"
                                className={"search-card-tab" + (isOsobowe ? " active" : "")}
                                onClick={() => vehicleTypeHandler("OSOBOWE")}
                            >
                                <span className="search-tab-icon search-tab-icon--car" />
                                <span>OSOBOWE</span>
                            </button>
                            <button
                                type="button"
                                className={"search-card-tab" + (!isOsobowe ? " active" : "")}
                                onClick={() => vehicleTypeHandler("DOSTAWCZE")}
                            >
                                <span className="search-tab-icon search-tab-icon--truck" />
                                <span>DOSTAWCZE</span>
                            </button>
                        </div>

                        <form className="search-card-form" action="">
                            <div className="search-toggle-row">
                                <span className={"search-toggle-label" + (!isPersonCustomer ? " active" : "")}>FIRMA</span>
                                <button
                                    type="button"
                                    className="search-toggle-switch"
                                    onClick={() => setCustomerType(isPersonCustomer ? availableCustomerTypes.company : availableCustomerTypes.person)}
                                    aria-label="Zmień typ klienta"
                                >
                                    <span className={"search-toggle-knob" + (isPersonCustomer ? " right" : "")}/>
                                </button>
                                <span className={"search-toggle-label" + (isPersonCustomer ? " active" : "")}>KONSUMENT</span>
                            </div>

                            <div className="search-inputs-row">
                                <BrandAndModelSearch
                                    brandsAndModels={searchOptions.brandsAndModels}
                                    onBrandChange={(brands) => changePropertyHandler("brands", brands)}
                                    onModelChange={(models) => changePropertyHandler("models", models)}
                                />
                            </div>

                            <div className="search-inputs-row">
                                <MultipleItemsSearchSelect
                                    items={segmentOrBodyItems}
                                    onChange={(values) => changePropertyHandler(segmentOrBodyKey, values)}
                                    placeholder="Nadwozie"
                                />
                                <MultipleItemsSearchSelect
                                    items={searchOptions.fuelTypes}
                                    onChange={(values) => changePropertyHandler("fuelTypes", values)}
                                    placeholder="Paliwo"
                                />
                            </div>

                            <div className="search-toggle-row">
                                <span className={"search-toggle-label" + (priceMode === "CENA" ? " active" : "")}>CENA</span>
                                <button
                                    type="button"
                                    className="search-toggle-switch"
                                    onClick={() => setPriceMode(priceMode === "RATA" ? "CENA" : "RATA")}
                                    aria-label="Przełącz między ceną a ratą"
                                >
                                    <span className={"search-toggle-knob" + (priceMode === "RATA" ? " right" : "")}/>
                                </button>
                                <span className={"search-toggle-label" + (priceMode === "RATA" ? " active" : "")}>RATA</span>
                            </div>

                            <RangeSelect
                                onChange={changeBudgetHandler}
                                items={rangeItems || []}
                                range={{from: rangeFrom, to: rangeTo}}
                                unit="zł"
                                placeholder={priceMode === "RATA" ? ["Rata od", "Rata do"] : ["Cena od", "Cena do"]}
                            />

                            <div className="search-checkbox-row">
                                <input
                                    type="checkbox"
                                    id="search-only-new"
                                    checked={onlyNew}
                                    onChange={e => setOnlyNew(e.target.checked)}
                                />
                                <label htmlFor="search-only-new">Tylko nowe auta</label>
                            </div>

                            <div className="search-card-buttons">
                                <button type="button" className="search-btn-primary" onClick={() => searchButtonClicked(false)}>
                                    <span>SPRAWDŹ OFERTY</span>
                                    <img src={logoIconWhite} alt="" className="search-btn-icon"/>
                                </button>
                                <button type="button" className="search-btn-secondary" onClick={() => searchButtonClicked(true)}>
                                    <span>WYSZUKIWANIE ZAAWANSOWANE</span>
                                    <img src={logoIcon} alt="" className="search-btn-icon"/>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <OurStrengths vehicleType={searchParameters.vehicleTypes} backgroundImage={ourStrengthsBackgroundImage}/>
            </div>
        </div>
    );
}

export default Intro;
